/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TeamPatchAuditLogEnum {
    INFO = 'info',
    LOCATION_PATCH = 'location_patch',
    LOCATION_DELETE = 'location_delete',
    LOCATION_ADD = 'location_add',
    SPONSOR_CREATE = 'sponsor_create',
    SPONSOR_PATCH = 'sponsor_patch',
    SPONSOR_DELETE = 'sponsor_delete',
    SUCCESS_CREATE = 'success_create',
    SUCCESS_PATCH = 'success_patch',
    SUCCESS_DELETE = 'success_delete',
}
